import { Blocklist } from '@/models/crow/block-list.model';
import { Recipient } from '@/models/crow/in-app-notification.model';

export interface NotificationsState {
  notifications: { [key: string]: any };
  featuredNotifications: { [key: string]: Recipient };
  blockList: { [key: string]: Blocklist };
  isLoading: boolean;
  isGetAllNotifications: boolean;
  take: number;
  orderby: string;
  showNotificationsModal: boolean;
}

const state: NotificationsState = {
  notifications: {},
  featuredNotifications: {},
  blockList: {},
  isLoading: false,
  isGetAllNotifications: false,
  take: 10,
  orderby: 'Mais recentes',
  showNotificationsModal: false,
};

export default state;
